import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { isSafari } from './isSafari';
import { SafariNoticeCard } from './SafariNoticeCard';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      return (
        <SignInPage
          {...props}
          providers={[
            {
              id: 'azure-auth-provider',
              title: 'Login',
              message: 'Sign in with your Equinor account',
              apiRef: microsoftAuthApiRef,
            },
          ]}
          titleComponent={isSafari(navigator.userAgent) ? <SafariNoticeCard /> : undefined}
        />
      );
    },
  },
});

export const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
